module.exports = __webpack_public_path__ + "static/img/com_bg.40e844e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/com_bg.png
// module id = BRwh
// module chunks = 1